import { request } from './client'
import { clearSession, saveLogin } from './session'
import type { Tenant, User } from './types'

interface LoginResponse {
  success: boolean
  message?: string
  user: User
  active_tenant?: Tenant
  tenant?: Tenant
  token: string
  refresh_token?: string
}

export async function login(email: string, password: string) {
  const res = await request<LoginResponse>('/auth/login', { body: { email: email.trim(), password } })
  saveLogin({ token: res.token, refreshToken: res.refresh_token, user: res.user, tenant: res.active_tenant ?? res.tenant ?? null })
  return res.user
}

export interface Me {
  user: User
  tenant?: Tenant
  tenant_required?: boolean
}

export const me = () => request<{ data: Me }>('/auth/me').then((r) => r.data)

export const authConfig = () =>
  request<{ registration_mode?: 'self_serve' | 'invite_only'; complex_password_enabled?: boolean }>('/auth/config')

/** 服务端会让这个账号所有地方的登录一起失效；本机的登录状态无论如何都清掉。 */
export async function logout() {
  let hubFailure: unknown
  try {
    await request('/hub/api/logout', { method: 'POST', body: {} })
  } catch (error) {
    hubFailure = error
  }
  try {
    await request('/auth/logout', { method: 'POST' })
  } finally {
    clearSession()
  }
  if (hubFailure) throw hubFailure
}
